// Typed wrappers for /api/v2/admin/roles.
// Separate from admin/users/api.ts — no cross-feature imports allowed.
// Note: endpoint not yet in openapi.yaml — uses adminFetch until schema is updated.
import { adminFetch, jsonRequest } from "@/lib/api/admin-fetch";

// Local types until /api/v2/admin/roles is added to openapi.yaml.
export type AdminRoleName = "admin" | "support";
export type AdminRoleSource = "env" | "db";

export interface AdminRoleItem {
  id: string;
  email: string;
  role: AdminRoleName;
  addedBy: string;
  createdAt: string;
  updatedAt: string;
  source: AdminRoleSource;
}
export interface AdminRoleList {
  items: AdminRoleItem[];
  limit: number;
  offset: number;
  total: number;
}
export interface AssignRoleBody {
  email: string;
  role: AdminRoleName;
}
export interface AssignRoleResult {
  id: string;
  email: string;
  role: AdminRoleName;
  addedBy: string;
}

export interface DeleteRoleBody {
  email: string;
}

export type ListRolesParams = { limit?: number; offset?: number };

/** Fetch paginated admin/support role assignments. */
export async function fetchAdminRoles(
  params: ListRolesParams,
): Promise<AdminRoleList> {
  const query = new URLSearchParams({
    limit: String(params.limit ?? 50),
    offset: String(params.offset ?? 0),
  });
  return adminFetch<AdminRoleList>(
    `/api/v2/admin/roles?${query}`,
    undefined,
    "fetchAdminRoles",
  );
}

/** Assign or update an admin/support role. */
export async function assignAdminRole(
  body: AssignRoleBody,
): Promise<AssignRoleResult> {
  return adminFetch<AssignRoleResult>(
    "/api/v2/admin/roles",
    jsonRequest("PUT", body),
    "assignAdminRole",
  );
}

/** Remove an admin/support role assignment by email. */
export async function deleteAdminRole(body: DeleteRoleBody): Promise<void> {
  const encodedEmail = encodeURIComponent(body.email);
  await adminFetch<unknown>(
    `/api/v2/admin/roles?email=${encodedEmail}`,
    { method: "DELETE" },
    "deleteAdminRole",
  );
}
